var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "url(#paint0_linear_1001_10101)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8335 14.6673C13.8335 14.2071 14.2066 13.834 14.6668 13.834H19.6668C20.1271 13.834 20.5002 14.2071 20.5002 14.6673C20.5002 15.1276 20.1271 15.5007 19.6668 15.5007H15.5002V19.6673C15.5002 20.1276 15.1271 20.5007 14.6668 20.5007C14.2066 20.5007 13.8335 20.1276 13.8335 19.6673V14.6673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3335 13.834C41.7937 13.834 42.1668 14.2071 42.1668 14.6673V19.6673C42.1668 20.1276 41.7937 20.5007 41.3335 20.5007C40.8733 20.5007 40.5002 20.1276 40.5002 19.6673V15.5007L36.3335 15.5007C35.8733 15.5007 35.5002 15.1276 35.5002 14.6673C35.5002 14.2071 35.8733 13.834 36.3335 13.834L41.3335 13.834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6668 42.1673C14.2066 42.1673 13.8335 41.7942 13.8335 41.334L13.8335 36.334C13.8335 35.8737 14.2066 35.5007 14.6668 35.5007C15.1271 35.5007 15.5002 35.8737 15.5002 36.334L15.5002 40.5007H19.6668C20.1271 40.5007 20.5002 40.8737 20.5002 41.334C20.5002 41.7942 20.1271 42.1673 19.6668 42.1673H14.6668Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1668 41.334C42.1668 41.7942 41.7937 42.1673 41.3335 42.1673H36.3335C35.8733 42.1673 35.5002 41.7942 35.5002 41.334C35.5002 40.8737 35.8733 40.5007 36.3335 40.5007H40.5002V36.334C40.5002 35.8737 40.8733 35.5007 41.3335 35.5007C41.7937 35.5007 42.1668 35.8737 42.1668 36.334V41.334Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 23.0007C23.4786 23.0007 20.1338 25.9891 19.0002 27.5007C18.7779 27.7969 18.7779 28.2044 19.0002 28.5007C20.1338 30.0122 23.4786 33.0007 28.0002 33.0007C32.5217 33.0007 35.8665 30.0122 37.0002 28.5007C37.2224 28.2044 37.2224 27.7969 37.0002 27.5007C35.8665 25.9891 32.5217 23.0007 28.0002 23.0007ZM24.8761 30.7578C23.0157 30.0666 21.5714 28.8898 20.7531 28.0007C21.5714 27.1115 23.0157 25.9347 24.8761 25.2435C24.2273 25.9781 23.8335 26.9434 23.8335 28.0007C23.8335 29.0579 24.2273 30.0232 24.8761 30.7578ZM31.1242 30.7578C32.9847 30.0666 34.4289 28.8898 35.2472 28.0007C34.4289 27.1115 32.9847 25.9347 31.1242 25.2435C31.7731 25.9781 32.1668 26.9434 32.1668 28.0007C32.1668 29.0579 31.7731 30.0232 31.1242 30.7578ZM25.5002 28.0007C25.5002 26.6199 26.6195 25.5007 28.0002 25.5007C29.3809 25.5007 30.5002 26.6199 30.5002 28.0007C30.5002 29.3814 29.3809 30.5007 28.0002 30.5007C26.6195 30.5007 25.5002 29.3814 25.5002 28.0007Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_10101",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectLogo);
export default __webpack_public_path__ + "static/media/object-logo.9539cc4aef2fb1bc6013afe5ebb78294.svg";
export { ForwardRef as ReactComponent };